

export class CountryStatusInput implements ICountryStatusInput {
    /** The auto-generated id of the country master */
    countryId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ICountryStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CountryStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new CountryStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICountryStatusInput {
    /** The auto-generated id of the country master */
    countryId: number;
    /** The updated status */
    status: number;
}

